import { render } from "./Side-Navbar.vue?vue&type=template&id=5c6a926a&scoped=true"
import script from "./Side-Navbar.vue?vue&type=script&lang=js"
export * from "./Side-Navbar.vue?vue&type=script&lang=js"

import "./Side-Navbar.vue?vue&type=style&index=0&id=5c6a926a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c6a926a"]])

export default __exports__